import { getBlob } from '../util/http';

const serializeParams = (params) => {
  const { dataPagamentoCoop, dataProcessamentoFinal, dataProcessamentoInicial } = params;

  return {
    ...params,
    entradaInicial: params.entradaInicial && params.entradaInicial.format('YYYY-MM'),
    entradaFinal: params.entradaFinal && params.entradaFinal.format('YYYY-MM'),
    dataProcessamentoInicial: dataProcessamentoInicial && dataProcessamentoInicial.format('YYYY-MM-DD'),
    dataProcessamentoFinal: dataProcessamentoFinal && dataProcessamentoFinal.format('YYYY-MM-DD'),
    dataPagamentoCoopInicial:
      dataPagamentoCoop && dataPagamentoCoop.inicial && dataPagamentoCoop.inicial.format('YYYY-MM-DD'),
    dataPagamentoCoopFinal:
      dataPagamentoCoop && dataPagamentoCoop.final && dataPagamentoCoop.final.format('YYYY-MM-DD'),
    carteiras: params.carteiras && params.carteiras.join(','),
  };
};

// eslint-disable-next-line import/prefer-default-export
export const buscarRelatorioOperacoes = (params) =>
  getBlob('/logs/operacoes/exportar', { params: serializeParams(params) });
